/**
 * Empty state card — icon in circle + heading + subtitle + CTA button.
 */
export function NexaEmpty({ icon: Icon, title, subtitle, action, testId }) {
  return (
    <div className="p-14 text-center" data-testid={testId}>
      <div className="mx-auto mb-4 w-11 h-12 rounded-full bg-nexa-canvas flex items-center justify-center">
        {Icon && <Icon className="w-5 h-5 text-nexa-mute" strokeWidth={1.5} />}
      </div>
      <h3 className="text-[16px] font-semibold text-nexa-ink">{title}</h3>
      {subtitle && (
        <p className="mt-2 text-[13.5px] text-nexa-mute max-w-[48ch] mx-auto">{subtitle}</p>
      )}
      {action && <div className="mt-6 inline-flex">{action}</div>}
    </div>
  );
}
